import React from "react"
import classnames from "classnames"
import styles from "./MyMazdaResetPassword.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import { InputEmail, Button, H3, Content, FormGroup, TickModalIcon } from "AtomicComponents"
import { HeroContent, AlertList } from "AtomicContainers"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formLinkSubmit } from "AtomicUtils/formHandler"
import MESSAGES from "AtomicConstants/MESSAGES"

class MyMazdaResetPassword extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    }
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { resetPasswordApiEndpoint } = this.props
        const { form } = this.state
        await fetchAPI({
          method: "POST",
          url: resetPasswordApiEndpoint,
          body: {
            username: form.email.value
          }
        })
          .then(async (response) => {
            const json = await response.json()
            const { success, errorMsg } = json
            if (!success) {
              this.setState({
                errorMessage: errorMsg || "null",
                loading: false
              })
            } else {
              // successful
              this.setState({
                loading: false,
                success: true
              }, () => {
                gtmHandler({
                  pageCategory: "MyMazda Reset password Form",
                  pageAction: "MyMazda Reset password Form - Reset my password"
                })
              })
            }
          })
          .catch((response) => {
            this.setState({
              errorMessage: response.message || `Failed with status ${response.status}`,
              loading: false
            })
          })
      })
    }
  }

  render() {
    const {
      buttonText = "Reset my password",
      successfulResetText,
      alreadyRegisteredHeading,
      alreadyRegisteredText,
      loginPageUrl,
      heading,
      blurb
    } = this.props
    const { loading, success, errorMessage } = this.state

    if (success) {
      return (
        <div className={classnames({ [styles.MyMazdaResetPassword]: true  })}>
          <div className={classnames({ [styles.MyMazdaResetPasswordForm]: true })}>
            <FormGroup>
              <TickModalIcon style={{ width: "2.25em", height: "2.25em", margin: "0 auto" }} />
              <HeroContent
                heading={"We've sent your reset link"}
                description={successfulResetText || "If it hasn’t appeared in your inbox, please check your junk folder."} />
              <Button styleName="black" href={loginPageUrl} fullWidth>
                Return to login
              </Button>
            </FormGroup>
          </div>
        </div>
      )
    }

    return (
      <div className={classnames({ [styles.MyMazdaResetPassword]: true })}>
        <div className={classnames({ [styles.MyMazdaResetPasswordForm]: true })}>
          <form method="POST" onSubmit={this._handleSubmit}>
            <FormGroup>
              <H3>{alreadyRegisteredHeading || heading || "Forgotten your password?"}</H3>
              <Content xmlString={alreadyRegisteredText || blurb} />
            </FormGroup>
            <FormGroup>
              <InputEmail name="email" label="Email address" {...fromLinkInputs(this, "email")} onBlur={() => {
                  gtmHandler({
                    pageCategory: "MyMazda Reset password Form",
                    pageAction:
                      "MyMazda Reset password Form - Entered \"EMAIL\""
                  })
                }} />
            </FormGroup>
            <FormGroup>
              {errorMessage &&
                <AlertList data={errorMessage} />
              }
              <Button styleName="black" loading={loading} fullWidth {...formLinkSubmit(this, this._handleSubmit)}>
                {buttonText}
              </Button>
            </FormGroup>
          </form>
        </div>
      </div>
    )
  }
}

export default MyMazdaResetPassword



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaResetPassword/MyMazdaResetPassword.jsx